<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Loader from "../components/loader";
import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxExport,
  DxFilterRow,
  DxStateStoring, DxRemoteOperations
} from "devextreme-vue/data-grid"; //DxSelection,
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import DxButton from "devextreme-vue/button";
import api from "@/axios";
import Swal from "sweetalert2";
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import moment from "moment";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  components: {
    DxDropDownButton,
    DxRemoteOperations,
    Layout,
    PageHeader,
    Loader,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxColumnFixing,
    DxExport,
    DxFilterRow,
    DxToolbar,
    DxItem,
    DxButton,
    DxStateStoring
  },
  data() {
    return {
      title: "Lista de Comissões",
      items: [
        { text: "Comissões", href: "/comissoes/list" },
        { text: "Lista de Comissões", active: true },
      ],
      loading: true,
      comissoes: [],
      represList: [],
      equipeList: [],
      showModalComissao: false,
      showEditModal: false,
      newComissao: {
        idRepres: null,
        vlrVenda: null,
      },
      editData: {},

      dataList: null,
      updating: false,
      showModalPeriodo: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      represSelected: 'TD',
      equipeSelected: 'TD',

      showModalErros: false,
      dtListErrors: [],
    };
  },

  created() {

  },
  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted comissoes-List')
    this.atualizaDataList();
  },

  methods: {
    abrirModalComissao() {
      console.log('abrirModalComissao')
      this.showModalComissao = true;
    },

    openEditModal(comissao) {
      this.editData = comissao.data; // Corrigir para acessar os dados corretamente
      this.showEditModal = true;
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    deleteComissao(id) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Deseja realmente excluir esta comissão?",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          api.post(`${getBaseUrl()}api/getcomiss`, {
            data: { id: id },
          }).then((response) => {
            if (response.data[0] == 1) {
              Swal.fire({
                position: "center",
                icon: "error",
                title: "Comissão não pode ser excluída!",
                text: "Comissão já foi calculada.",
                showConfirmButton: true,
              });
            } else {
              return api.post(`${getBaseUrl()}api/excluircomissao`, { data: { id: id } });
            }
          }).then(() => {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Comissão excluída com sucesso!",
              showConfirmButton: false,
              timer: 1500,
            });
            this.showEditModal = false;
            this.fetchComissoes();
          });
        }
      });
    },

    deleteSelectedComissoes() {
      const selectedRows = this.dataGrid.getSelectedRowKeys();
      if (selectedRows.length === 0) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Nenhuma comissão selecionada",
          text: "Por favor, selecione pelo menos uma comissão para excluir.",
          showConfirmButton: true,
        });
        return;
      }

      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Deseja realmente excluir as comissões selecionadas?",
        text: `${selectedRows.length} comissão(ões) serão excluídas.`,
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          console.log('selectedRows')
          console.log(selectedRows)
          const deletePromises = selectedRows.map(id =>
            // console.log(row)
            api.post(`${getBaseUrl()}api/excluircomissao`, { data: { id: id } })
          );

          Promise.all(deletePromises)
            .then(() => {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Comissões excluídas com sucesso!",
                showConfirmButton: false,
                timer: 1500,
              });
              this.fetchComissoes();
            })
            .catch((error) => {
              console.error("Erro ao excluir comissões:", error);
              Swal.fire({
                position: "center",
                icon: "error",
                title: "Erro ao excluir comissões",
                text: "Não foi possível excluir algumas comissões. Tente novamente mais tarde.",
                showConfirmButton: true,
              });
            });
        }
      });
    },

    fetchComissoes() {
      console.log('fetchComissoes')
      this.loading = true;
      api.post(`${getBaseUrl()}api/getcomiss`)
        .then((response) => {
          console.log('then axios')
          console.log(response.data)
          this.comissoes = response.data[0];
          this.represList = response.data[1];
          // console.log('representantes')
          // this.representantes.forEach((representante) => {
          //   console.log(representante.descricao);
          // });
          this.loading = false;
        })
        .catch((error) => {
          console.error("Erro ao buscar comissões:", error);
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Erro ao carregar comissões",
            text: "Não foi possível carregar as comissões. Tente novamente mais tarde.",
            showConfirmButton: true,
          });
          this.loading = false;
        });
    },

    postcomissao() {
      console.log('postcomissao')
      const payload = {
        data: { id: this.id },
      };

      console.log('payload')
      console.log(payload)

      api.post(`${getBaseUrl()}api/postcomissao`, payload)
        .then(() => {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Comissão criada com sucesso!",
            showConfirmButton: false,
            timer: 1500,
          });
          this.abrirModalComissao = false;
          this.fetchComissoes();
        })
        .catch((error) => {
          console.error("Erro ao criar comissão:", error);
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Erro ao criar comissão",
            text: "Não foi possível criar a comissão. Tente novamente mais tarde.",
            showConfirmButton: true,
          });
        });
    },

    criarparatodos() {
      console.log('criarparatodos')

      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Criar comissões para todos os representantes?",
        text: "Esta ação irá criar comissões para todos os representantes cadastrados.",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          api.get(`${getBaseUrl()}api/criarparatodos`)
            .then(() => {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Comissões criadas com sucesso!",
                showConfirmButton: false,
                timer: 1500,
              });
              this.abrirModalComissao = false;
              this.fetchComissoes();
            })
            .catch((error) => {
              console.error("Erro ao criar comissões:", error);
              Swal.fire({
                position: "center",
                icon: "error",
                title: "Erro ao criar comissões",
                text: "Não foi possível criar as comissões. Tente novamente mais tarde.",
                showConfirmButton: true,
              });
            });
        }
      });
    },

    saveEdit() {
      const payload = {
        data: { ...this.editData },
      };
      api.post(`${getBaseUrl()}api/atualizarcomiss`, payload)
        .then(() => {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Comissão atualizada com sucesso!",
            showConfirmButton: false,
            timer: 1500,
          });
          this.showEditModal = false;
          this.fetchComissoes();
        })
        .catch((error) => {
          console.error("Erro ao atualizar comissão:", error);
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Erro ao atualizar comissão",
            text: "Não foi possível atualizar a comissão. Tente novamente mais tarde.",
            showConfirmButton: true,
          });
        });
    },

    onFilterRepres(e){
      console.log('onFilterRepres')
      // console.log(e.itemData)
      const represSelcted = e.itemData;
      this.represSelected = represSelcted;

      this.atualizaDataList();
    },

    onFilterEquipe(e){
      console.log('onFilterRepres')
      // console.log(e.itemData)
      const equipeSelcted = e.itemData;
      this.equipeSelected = equipeSelcted;

      this.atualizaDataList();
    },

    comissaoCalc(){
      console.log('comissoes/calc: ')
      const routeData = this.$router.resolve(`/comissoes/calc`)
      window.open(routeData.href, '_blank')
    },

    calcularcomiss() {
      console.log('calcularcomiss')
      // console.log(this.dataList)

      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Deseja EFETIVAR as comissões após calculadas?",
        text: "Ao efetivar as comissões será gerado a ComissãoCalc com o status 'EF' (efetivado). " +
            "Caso opte por não efetivar, a ComissãoCalc será gerada com o status 'NEF' (não efetivado) " +
            "e ficará disponível para efetivação posterior na tela de Comissões Calc.",
        showConfirmButton: true,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Efetivar",
        denyButtonText: "Não Efetivar",
      }).then((confirmed) => {

        let stsComisCalc = confirmed.isConfirmed ? "EF" : confirmed.isDenied ? "NEF" : null;

        if(confirmed.isConfirmed){
          console.log('Efetivar cálculo de comissão, ComissaoCalc com stt = ' , stsComisCalc )
        } else if(confirmed.isDenied) {
          console.log('Não efetivar cálculo de comissão, ComissaoCalc com stt = ' , stsComisCalc)
        }

        if(stsComisCalc) {

          const ids = this.dataList.map(item => item.comissao_id);

          this.updating = true
          api.post(`${getBaseUrl()}api/calculacomissao`, {
            'idsData': ids,
            'stsComisCalc': stsComisCalc,
          }).then((res) => {
            console.log('then axios calcular comissão')
            console.log(res.data)

            if (!res.data.success) {
              if (!res.data.contem) {
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: res.data.error,
                  text: res.data.message,
                  showConfirmButton: false,
                  showCancelButton: false,
                })
              } else {
                Swal.fire({
                  position: "center",
                  icon: "warning",
                  title: res.data.error,
                  text: res.data.message,
                  showConfirmButton: true,
                  showCancelButton: true,
                  confirmButtonText: "Visualizar Divergências",
                  cancelButtonText: "Sair",
                }).then((confirmed) => {
                  if (confirmed.isConfirmed) {

                    this.dtListErrors = res.data.listErrors
                    this.showModalErros = true
                  }
                })
              }
              this.updating = false
            } else {
              if (res.data.success === true) {
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: 'Comissões calculadas com sucesso!',
                  text: res.data.message,
                  showConfirmButton: false,
                  timer: 3500,
                }).then(() => {
                  this.comissaoCalc()
                })
              } else {
                Swal.fire({
                  position: 'top-end',
                  icon: 'error',
                  title: res.data.message,
                  showConfirmButton: false,
                  timer: 3000
                })
              }
            }
            this.atualizaDataList()
          })
              .catch((error) => {
                console.error("Erro ao calcular comissões:", error);
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: "Erro ao calcular comissões",
                  text: "Não foi possível calcular as comissões. Contate o suporte!",
                  showConfirmButton: true,
                });
              });
        }
      })
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'findi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'findf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))


      this.showModalPeriodo = false
      this.atualizaDataList()
    },


    atualizaDataList(){
      console.log('atualizaDataList_comissao')
      this.loading = true;
      const filtros = JSON.parse(localStorage.getItem("filtros"))
      if (!filtros) {
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'findi': perIniPadrao,
          'findf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['findi']
        this.dtFimFiltro = filtros['findf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      const paramsReq = {
        'di': di,
        'df': df,
        'represSelected': this.represSelected.id,
        'equipeSelected': this.equipeSelected.id,
      }

      // console.log('paramsReq: ' , paramsReq)

      api.get(`${getBaseUrl()}api/getcomissao`, {
        params: paramsReq
      }).then(response => {
        console.log('response: ', response.data)
        this.dataList = response.data[0];
        const represList = response.data[2] ?? []
        const eqiupeList = response.data[3] ?? []
        this.represList = [{id: 'TD', descricao: 'Selecionar Todos'}, ...represList];
        this.equipeList = [{id: 'TD', nome: 'Selecionar Todos'}, ...eqiupeList];
        this.loading = false;
      })
      .catch((error) => {
        console.error("Erro ao buscar comissões:", error);
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Erro ao carregar comissões",
          text: "Não foi possível carregar as comissões. Tente novamente mais tarde.",
          showConfirmButton: true,
        });
        this.loading = false;
      });
    },


    carregouGrid(e){
      console.log('carregouGrid')

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `(${e.component.totalCount()}) Comissões: ${dtIniFormated} - ${dtFimFormated}`
    },

    onRowDblClick() {
      console.log('onRowDblClick')
      this.comissaoCalc()
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "comissao_status") {
          const statusComissao = e.data.comissao_status

          let corStatus = 'rgba(248,178,58,0.82)'

          switch (statusComissao) {
            case 'CO':
              corStatus = 'rgba(46,184,134,0.96)'
              break
            case 'AB':
              corStatus = 'rgba(248,178,58,0.82)'
              break
          }


          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    nomeStatus(e) {
      if (e.value === "CO") {
        return 'Concluído'
      } else {
        return 'Em Aberto'
      }
    },

    nomeTipoRepres(e) {
      if (e.value === 1) {
        return 'Líder'
      } else {
        return 'Padrão'
      }
    },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <Loader v-if="loading" style="min-height: 400px;"></Loader>

    <div v-if="!loading">
      <DxToolbar>
        <DxItem location="before" widget="dxButton">
          <DxButton
            icon="refresh"
            hint="Atualizar lista"
            :on-click="atualizaDataList"
          />
        </DxItem>

        <DxItem location="before" widget="dxButton">
          <DxButton
            icon="plus"
            hint="Calcular Comissão"
            text="Calcular Comissão"
            :on-click="calcularcomiss"
            />
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxDropDownButton
              v-model="represSelected"
              :items="represList"
              :drop-down-options="{ width: 150 }"
              :style="{ maxWidth: '180px' }"
              icon="user"
              :text="represSelected.descricao ?? 'Selectione Repres.'"
              show-arrow="false"
              hint="Filtrar Status"
              display-expr="descricao"
              value-expr="id"
              @item-click="onFilterRepres"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxDropDownButton
              v-model="equipeSelected"
              :items="equipeList"
              :drop-down-options="{ width: 150 }"
              :style="{ maxWidth: '180px' }"
              icon="group"
              :text="equipeSelected.nome ?? 'Selectione Equipe'"
              show-arrow="false"
              hint="Filtrar Status"
              display-expr="nome"
              value-expr="id"
              @item-click="onFilterEquipe"/>
        </DxItem>
      </DxToolbar>


      <DxDataGrid
        ref="dataGridRefKey"
        :data-source="dataList"
        :keyExpr="'comissao_id'"
        :show-borders="true"
        :focused-row-enabled="true"
        :column-auto-width="true"
        :show-row-lines="true"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :row-alternation-enabled="true"
        @content-ready="carregouGrid"
        @cell-prepared="onCellPrepared"
        @row-dbl-click="onRowDblClick"
        @exporting="onExporting"
      >
        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />

        <DxColumnChooser :enabled="true" />
        <DxColumnFixing :enabled="true" />
        <DxFilterRow :visible="true" />
        <DxExport :enabled="true" :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strMovList"/>

        <DxColumn
            data-field="comissao_id"
            caption="ID"
            data-type="number"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="comissao_cod"
            caption="Cód. representante"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="comissao_nome"
            caption="Nome"
            alignment="left" />

        <DxColumn
            data-field="repres_lider"
            caption="Tipo Repres."
            alignment="left"
            data-type="text"
            :customize-text="nomeTipoRepres"/>

        <DxColumn
            data-field="comissao_status"
            caption="Status"
            alignment="left"
            data-type="text"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="comissaocalc_id"
            caption="ID ComissaoCalc."
            alignment="left"
            data-type="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="financeiro_id"
            caption="ID Financ."
            alignment="left"
            data-type="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="represtime_nome"
            caption="Equipe"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true" />

        <DxColumn
            data-field="comissao_venda"
            caption="Vlr. Venda"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="created_at"
            caption="Criação"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>


      <!-- <template #actionsTemplate="{ data }">
        <DxButton
          icon="edit"
          hint="Editar"
          :on-click="() => openEditModal(data)"
        />
        <DxButton
          icon="trash"
          hint="Excluir"
          :on-click="() => deleteComissao(data.id)"
        />
      </template> -->
      </DxDataGrid>
    </div>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal v-model="showEditModal" title="Editar Comissão" hide-footer>
      <form>
        <div class="mb-3">
          <label for="totpedido">Total de Pedidos</label>
          <input id="totpedido" v-model="editData.totpedido" type="number" class="form-control" />
        </div>
        <div class="mb-3">
          <label for="percent">Percentual</label>
          <input id="percent" v-model="editData.percent" type="number" class="form-control" />
        </div>
        <div class="mb-3">
          <label for="venda">Total de Vendas</label>
          <input id="venda" v-model="editData.venda" type="number" class="form-control" />
        </div>
        <div class="mb-3">
          <label for="debitoclientes">Débito dos Clientes</label>
          <input id="debitoclientes" v-model="editData.debitoclientes" type="number" class="form-control" />
        </div>
        <div class="mb-3">
          <label for="totalretido">Total Retido</label>
          <input id="totalretido" v-model="editData.totalretido" type="number" class="form-control" />
        </div>
        <div class="mb-3">
          <label for="premio">Prêmio</label>
          <input id="premio" v-model="editData.premio" type="number" class="form-control" />
        </div>
        <div class="mb-3">
          <label for="debito">Débito</label>
          <input id="debito" v-model="editData.debito" type="number" class="form-control" />
        </div>
        <div class="text-end">
          <b-button variant="light" @click="showEditModal = false">Cancelar</b-button>
          <b-button variant="success" @click="saveEdit">Salvar</b-button>
          <b-button variant="danger" @click="deleteComissao(editData.id)">Excluir</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal
        v-model="showModalErros"
        id="showModalErros"
        size="lg"
        title="Erros gerados na ação"
        title-class="font-18"
        hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                  <tr>
                    <th>Erro</th>
                    <th>Detalhe Erro</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in dtListErrors" :key="data.id">
                    <td>{{data.error}}</td>
                    <td>{{data.msgError}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

